// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-list {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 0px 15px 5px 15px;
}

.file-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 8px;
  margin: 0px 15px 0px 0px;
  padding: 0px 0px 0px 15px;
}

.file-list-upload {
  display: flex;
  min-height: 4cm;
  max-height: 10cm;
  overflow-y: auto;
  scroll-behavior: smooth;
}

.card{
  border-radius: 8px !important;
}

.add-file-card {
  flex: 0 0 auto;
  margin: 0px 10px 0px 0px;
  background-color: var(--app-white);
  width: 3cm;
  height: 3cm;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.file-card {
  flex: 0 0 auto;
  margin: 0px 10px 0px 0px;
  background-color: var(--app-white);
  width: 3cm;
  height: 3cm;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-card-md {
  display: flex;
  flex-direction: column;
  margin: 0px 0px 10px 0px;
  background-color: var(--app-white);
  width: 4cm;
  height: 4cm;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-bottom: 16px;
}

.file-title {
  color: var(--app-white);
  background-color: var(--app-ink-alpha-600);
  border: none;
  border-radius: 0px 0px 3px 3px;
  width: 100%;
  height: 20%;
  position: absolute;
  bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 3px;
}

.file-description {
  color: var(--app-white);
  background-color: var(--app-ink-alpha-600);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  width: 100%;
  height: 20%;
  position: absolute;
  bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 3px;
}

.file-upload {
  margin-bottom: 10px;
}

.file-card-content {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.icon-title {
  font-size: var(--app-font-size-22px);
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
}

.icon-viewer {
  font-size: var(--app-font-size-22px);
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}

.icon-delete {
  font-size: var(--app-font-size-22px);
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.img-proportional {
  width: auto;
  max-width: 100%;
  max-height: 92dvh !important;
  margin: 0 auto;
}

.mdi-information-variant-circle-outline { color: var(--app-primary); cursor: pointer; }
.mdi-delete-circle { color: var(--app-primary); font-size: var(--app-font-size-icon-medium); cursor: pointer; }
.add-file-card { border-top: 2px solid var(--app-primary) !important; }
.mdi-plus-circle { color: var(--app-primary); font-size: var(--app-font-size-icon-add); line-height: 1; }
.mdi-delete-circle-outline, .mdi-pencil-circle-outline { color: var(--app-white); }
.mdi-delete-circle, .mdi-pencil-circle { color: var(--app-primary); }

.add-file-card small {
  font-size: var(--app-font-size-12px);
  line-height: 1.25;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/file-upload-selector/file-upload-selector.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,kCAAkC;EAClC,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,kCAAkC;EAClC,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,kCAAkC;EAClC,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,8BAA8B;EAC9B,+BAA+B;EAC/B,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,0CAA0C,yBAAyB,EAAE,eAAe,EAAE;AACtF,qBAAqB,yBAAyB,EAAE,2CAA2C,EAAE,eAAe,EAAE;AAC9G,iBAAiB,mDAAmD,EAAE;AACtE,mBAAmB,yBAAyB,EAAE,wCAAwC,EAAE,cAAc,EAAE;AACxG,yDAAyD,uBAAuB,EAAE;AAClF,yCAAyC,yBAAyB,EAAE;;AAEpE;EACE,oCAAoC;EACpC,iBAAiB;AACnB","sourcesContent":[".file-list {\n  display: flex;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  padding: 0px 15px 5px 15px;\n}\n\n.file-footer {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0 8px;\n  margin: 0px 15px 0px 0px;\n  padding: 0px 0px 0px 15px;\n}\n\n.file-list-upload {\n  display: flex;\n  min-height: 4cm;\n  max-height: 10cm;\n  overflow-y: auto;\n  scroll-behavior: smooth;\n}\n\n.card{\n  border-radius: 8px !important;\n}\n\n.add-file-card {\n  flex: 0 0 auto;\n  margin: 0px 10px 0px 0px;\n  background-color: var(--app-white);\n  width: 3cm;\n  height: 3cm;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.file-card {\n  flex: 0 0 auto;\n  margin: 0px 10px 0px 0px;\n  background-color: var(--app-white);\n  width: 3cm;\n  height: 3cm;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.file-card-md {\n  display: flex;\n  flex-direction: column;\n  margin: 0px 0px 10px 0px;\n  background-color: var(--app-white);\n  width: 4cm;\n  height: 4cm;\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n  margin-bottom: 16px;\n}\n\n.file-title {\n  color: var(--app-white);\n  background-color: var(--app-ink-alpha-600);\n  border: none;\n  border-radius: 0px 0px 3px 3px;\n  width: 100%;\n  height: 20%;\n  position: absolute;\n  bottom: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-left: 3px;\n}\n\n.file-description {\n  color: var(--app-white);\n  background-color: var(--app-ink-alpha-600);\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  width: 100%;\n  height: 20%;\n  position: absolute;\n  bottom: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-left: 3px;\n}\n\n.file-upload {\n  margin-bottom: 10px;\n}\n\n.file-card-content {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.icon-title {\n  font-size: var(--app-font-size-22px);\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n}\n\n.icon-viewer {\n  font-size: var(--app-font-size-22px);\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: pointer;\n}\n\n.icon-delete {\n  font-size: var(--app-font-size-22px);\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n}\n\n.img-proportional {\n  width: auto;\n  max-width: 100%;\n  max-height: 92dvh !important;\n  margin: 0 auto;\n}\n\n.mdi-information-variant-circle-outline { color: var(--app-primary); cursor: pointer; }\n.mdi-delete-circle { color: var(--app-primary); font-size: var(--app-font-size-icon-medium); cursor: pointer; }\n.add-file-card { border-top: 2px solid var(--app-primary) !important; }\n.mdi-plus-circle { color: var(--app-primary); font-size: var(--app-font-size-icon-add); line-height: 1; }\n.mdi-delete-circle-outline, .mdi-pencil-circle-outline { color: var(--app-white); }\n.mdi-delete-circle, .mdi-pencil-circle { color: var(--app-primary); }\n\n.add-file-card small {\n  font-size: var(--app-font-size-12px);\n  line-height: 1.25;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
